import { useEffect } from "react";
import { observer } from "mobx-react-lite";
import { useParams, Link } from "react-router-dom";
import licensesStore from "../../../stores/licensesStore";
import LicenseFormFields from "./licenseFormFields";
import styles from "../License.module.css";

const EditLicense = () => {
  const { licenseId } = useParams();

  const {
    getSpecificLicense,
    isLoadingSpecificLicense,
    specificLicense,
    updateLicense,
  } = licensesStore;

  useEffect(() => {
    getSpecificLicense(licenseId);
  }, []);

  const onSubmitUpdate = (values) => {
    const formData = new FormData();
    Object.keys(values).forEach((key) => {
      if (
        key === "filename" &&
        values.filename &&
        typeof values.filename !== "string"
      ) {
        formData.append(key, values.filename);
      } else if (key !== "filename") {
        formData.append(key, values[key]);
      }
    });
    updateLicense({
      id: licenseId,
      payload: formData,
    });
  };

  return (
    !isLoadingSpecificLicense && (
      <div className={styles.wrapper}>
        <div className="container-responsive">
          <div className={styles.editHeader}>
            <Link to={"/license"}>Go Back</Link>
            <h4>Modify License {specificLicense?.license_description}</h4>
          </div>

          <LicenseFormFields
            initialValues={specificLicense}
            onSubmit={onSubmitUpdate}
            editMode
          />
        </div>
      </div>
    )
  );
};

export default observer(EditLicense);
